// src/pages/Home.js
import React from 'react';
import { Hero } from '../components/layout/Hero';
import Products from '../components/layout/Products';

function Home() {
  return (
    <>
      <Hero />
      <Products />
    </>
  );
}

export default Home;

